import styled from 'styled-components'

import { Colors } from 'common-constants/colors'
import { RouterLink } from 'components/presentational/link'

export const SeoLink = styled(RouterLink)`
  color: ${Colors.link};
`
